<!--  -->
<template>
  <div>
    <div class="asdatw">
      <div class="explain">
        <div>说明：</div>
        <div>1.默认0点开始+24点结束。</div>
      </div>
      <div class="sdaraw">
        <div>2.若开启客服消息则会在活动期间第一天20:00-22:00推送一次</div>
        <div>3.多个活动推送日期重合则仅推送最后配置的活动。</div>
        <div>4.当设置充值金额为0.1-9元时，赠券金额上限为充值金额5倍，且最大不能超过1800书券。9元以上最大不超过金额1.5倍。</div>
        <div>5.用户圈定仅限制活动运营位展示，不限制用户参与机会（即非标签范围内的用户不可见书城内该活动的运营位，但可通过链接参与该活动）。</div>
      </div>
    </div>
    <div class="active_box">
      <div class="active_name">
        <div class="acwc_name">活动名称</div>
        <el-input v-model="activityname" v-model.trim="activityname" style="width:230px" placeholder="请输入内容" @input="activityname = activityname.replace(reg, '')" />
      </div>
      <div class="active_name">
        <div class="acwc_name">活动主题</div>
        <el-tag v-if="styleid !== null" size="medium" style="height:35px;line-height:35px;margin-right:10px;padding: 0 23px;">{{ stylename }}</el-tag>
        <el-button type="primary" @click="choosetheme"> 选择活动主题 </el-button>
      </div>
      <div class="active_name">
        <div class="acwc_name">充值档位</div>
        <div class="sendr_box">
          <div class="sednwrrw">价位</div>
          <el-input v-model.number="sendmoney" min="0" type="number" class="senadw_input" style="width:104px;border:none" placeholder="请输入" />
          <div class="saewds">元</div>
        </div>
        <div class="sendr_box" style="margin-left:10px">
          <div class="sednwrrw">赠送</div>
          <el-input v-model.number="certificate" type="number" class="senadw_input" style="width:104px;border:none" placeholder="请输入" @mousewheel.native.prevent />
          <div class="saewds">书券</div>
        </div>
      </div>
      <div class="active_name">
        <div class="acwc_name">充值次数</div>
        <el-select v-model="frequency" placeholder="请选择" @change="selxdzrcghage">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <!-- <div class="active_name">
        <div class="acwc_name">总充值次数</div>
        <el-select v-model="rechargeCount" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div> -->
      <div class="active_name">
        <div class="acwc_name">期限选择</div>
        <el-select v-model="time_type" placeholder="请选择">
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="time_type === 2" class="active_name">
        <div class="acwc_name">固定天数</div>
        <el-input v-model="appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="appoint_day = appoint_day.replace(/[^A-z0-9]/, '')" />
      </div>

      <div v-if="time_type === 1" class="active_name">
        <div class="acwc_name">活动时间</div>
        <el-date-picker
          v-model="timevalue"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          :clearable="false"
          style="width:430px"
          @change="timechanger"
        />
      </div>
      <div class="active_name">
        <div class="acwc_name">活动时间状态</div>
        <el-switch
          v-model="timestatus"
          active-color="#46a6ff"
          inactive-color="rgb(238, 238, 238)"
          active-value="1"
          inactive-value="0"
        />
        <span style="margin-left:10px" :class="[timestatus === '1' ? 'icon':'noicon']">显示</span>
      </div>

      <div class="active_name">
        <div class="acwc_name">活动展示位</div>
        <div>
          <!-- <el-checkbox-group
            v-model="checkList"
          >
            <el-checkbox
              v-for="item in themarr"
              :key="item.description"
              :label="item.value"
            >
              {{ item.description }}
            </el-checkbox>
          </el-checkbox-group> -->
          <el-checkbox v-model="banner" :true-label="1" :false-label="0">阅读页banner</el-checkbox>
          <el-checkbox v-model="open_spread" :true-label="1" :false-label="0">客服消息</el-checkbox>
          <el-checkbox v-model="indexbanner" :true-label="1" :false-label="0">首页banner</el-checkbox>
          <el-checkbox v-model="centerbanner" :true-label="1" :false-label="0">活动中心</el-checkbox>
        </div>
      </div>

      <div class="active_name">
        <div class="acwc_name">用户圈定</div>
        <div>
          <el-radio-group v-model="delineationradio">
            <div class="dada">
              <el-radio :label="0">任意用户：无门槛限制</el-radio>
            </div>
            <div class="dada">
              <el-radio :label="1">老用户：注册2天及以上的用户（排除48小时新用户）</el-radio>
            </div>
            <div class="dada">
              <el-radio :label="2">全量未充值用户（排除新用户）：注册2天及以上&从未充值用户</el-radio>
            </div>
            <div class="dada">
              <el-radio :label="3">1周未充值用户：注册7天及以上&7天内未充值用户</el-radio>
            </div>
            <div class="dada">
              <el-radio :label="4">2周未充值用户：注册14天及以上&14天内未充值用户</el-radio>
            </div>
          </el-radio-group>
        </div>
      </div>
      <div class="ribbon_box">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="determine">确定</el-button>
      </div>
    </div>
    <el-dialog
      title="活动主题选择"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="58%"
    >
      <themedialog ref="themeview" @close="close" />
    </el-dialog>
  </div>
</template>

<script>
import themedialog from './themedialog.vue'
import { readingservice, acawraccountlist } from '@/api/sourceMaterial.js'
export default {
  components: {
    themedialog
  },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      activityname: '', // 活动名称
      dialogVisible: false,
      stylename: '', // 选择活动主题
      styleid: null, // 选择活动主题id
      sendmoney: '', // 价位
      certificate: 0, // 书券
      frequency: null, // 充值次数
      dayRepeat: null, // 选择每日充值一次时传1，其余选0(隐藏参数)
      frequencytwo: null, // 参数二 防止影响参数 （充值次数）
      // rechargeCount: null, // 总充值次数
      options: [{
        label: '1次',
        value: 1
      },
      {
        label: '2次',
        value: 2
      }, {
        label: '3次',
        value: 3
      },
      {
        label: '每日一次',
        value: 4
      }],
      timevalue: [], // 绑定开始结束时间的数组
      startTime: '', // 活动开始时间
      endTime: '', // 活动结束时间
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      timestatus: '1', // 活动时间状态
      // checkList: [], // 活动展示位选中的数组
      // themarr: [], // 活动展示位数组
      banner: 0,
      open_spread: 0,
      indexbanner: 0,
      centerbanner: 0,
      delineationradio: 0, // 用户圈定 不用传此参数 只是展示
      theme: [],
      appoint_day: '',
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2
    }
  },
  created() {
    console.log('platformid', this.platformid)
    this.getactivry()
  },
  mounted() {

  },
  methods: {
    choosetheme() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.themeview.send(this.theme)
      })
    },
    close(item) {
      console.log('item', item)
      this.dialogVisible = false
      this.stylename = item.description
      this.styleid = item.value
    },
    timechanger(val) {
      console.log('val', this.timevalue)
      this.startTime = this.timevalue[0]
      this.endTime = this.timevalue[1]
    },
    cancel() {
      this.$emit('close')
    },
    selxdzrcghage(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 4) {
        this.dayRepeat = 1
      } else {
        this.dayRepeat = 0
      }
    },
    async getactivry() {
      // 获取主题
      const data = await acawraccountlist({
        platformId: this.platformid,
        activityType: 1
      })
      this.stylename = data.data.theme[0].description
      this.styleid = data.data.theme[0].value
      this.theme = data.data.theme
      console.log('data', data.data.theme[0].description, data.data.theme[0].value)
    },
    async determine() {
      // // console.log('frequency充值次数', this.frequency)
      // console.log('dayRepeat隐藏参数', this.dayRepeat)
      // console.log('frequencytwo隐藏参数', this.frequencytwo)

      if (this.activityname === '') {
        this.$message.error('请输入活动名称')
        return
      }
      if (this.sendmoney === '') {
        this.$message.error('请输入价位')
        return
      }
      if (this.certificate === '') {
        this.$message.error('请输入赠送书券')
        return
      }

      if (this.frequency === null) {
        this.$message.error('请选择充值次数')
        return
      }

      if (this.time_type === 1) {
        if (this.startTime === '' && this.endTime === '') {
          this.$message.error('请选择活动开始时间')
          return
        }
      } else {
        if (this.appoint_day === '') {
          this.$message.error('固定期限不能为空')
          return
        }
        if (this.appoint_day.length > 3) {
          this.$message.error('固定天数不能超过3位')
          return
        }
      }

      // eslint-disable-next-line eqeqeq
      if (this.frequency == 4) {
        this.frequencytwo = 1
      } else {
        this.frequencytwo = this.frequency
      }
      const par = {}
      if (this.time_type === 1) {
        par.time_type = this.time_type
        par.start_time = this.startTime
        par.end_time = this.endTime
      } else {
        par.time_type = this.time_type
        par.appoint_day = Number(this.appoint_day)
      }
      const data = await readingservice({
        ...par,
        platform_id: this.platformid,
        activity_type: 1,
        activity_info: {
          acname: this.activityname, // 活动名称
          tpl: this.styleid,
          amount: this.sendmoney, // 充值档位
          free: this.certificate, // 赠送书券
          dayRepeat: this.dayRepeat,
          // start_time: this.startTime,
          // end_time: this.endTime,
          open_showtime: this.timestatus,
          banner: this.banner,
          open_spread: this.open_spread,
          indexbanner: this.indexbanner,
          centerbanner: this.centerbanner,
          totalFrequency: this.frequencytwo,
          user_filte: this.delineationradio
        }
      })
      console.log('data', data)
      this.$message({
        type: 'success',
        message: '添加成功!'
      })
      this.$emit('close')
      // console.log('活动名称', this.activityname)
      // console.log('活动主题', this.styleid)
      // console.log('价位', this.sendmoney)
      // console.log('赠送', this.certificate)
      // console.log('充值次数', this.frequency)
      // console.log('开始时间', this.startTime)
      // console.log('结束时间', this.endTime)
      // console.log('活动时间状态', this.timestatus)
      // console.log('活动展示位', this.checkList)
      // console.log('总充值次数', this.rechargeCount)
      // console.log('转', typeof (this.checkList.toString()), this.checkList.toString())
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.asdatw{
    font-size: 13px;
    line-height: 20px;
    color: #f2a818;
}
.explain{
  display: flex;
  align-items: center;
}
.sdaraw{
  margin-left: 40px;
}
.active_box{
  padding-left: 8px;
}
.active_name{
  display: flex;
  align-items: center;
  margin-top: 25px;
}
.acwc_name{
  margin-right: 10px;
  width: 90px;
  text-align: right;
}
.sendr_box{
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 6px;
}
.sednwrrw{
  width: 70px;
  height: 35px;
  line-height: 35px;
  background-color: #f5f7fa;
  color: #909399;
  box-sizing: border-box;
  text-align: center;
  border-radius: 6px 0px 0px 6px;
  border-right: 1px solid #ccc;;
}
.saewds{
  width: 70px;
  height: 35px;
  line-height: 35px;
  background-color: #f5f7fa;
  color: #909399;
  box-sizing: border-box;
  text-align: center;
  border-radius: 0px 6px 6px 0px;
  border-left: 1px solid #ccc;;
}
 .sendr_box>>>.el-input__inner {
    border: 0;
  }
.icon{
 color: #46a6ff;
}
.noicon{
  color: rgb(238, 238, 238);
}
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"]{
  -webkit-appearance:textfield;
  -moz-appearance:textfield;
  -o-appearance:textfield;
  -ms-appearance:textfield;
  appearance:textfield;
}
/* 去掉input尾部上下小箭头 end */
.ribbon_box{
  margin-top: 40px;
  text-align: right;
}
.dada{
  margin-bottom: 10px;
}
::v-deep .el-input__inner::-webkit-outer-spin-button,
::v-deep .el-input__inner::-webkit-inner-spin-button {
-webkit-appearance: none;
 }
::v-deep .el-input__inner[type='number'] {
-moz-appearance: textfield;
 }
 .el-radio-group .dada .el-radio__label{
      font-size:14px ;
    }
 @media (max-width: 768px){
  .asdatw,
  .acwc_name ,.el-radio__label{
    font-size: 2.8vw;
  }
    .el-radio-group .dada .el-radio__label{
      font-size:2.8vw !important;
    }
 }
</style>
